import { FC, useMemo } from "react";
import { Box } from "@otrium/core";
import { CTPrice } from "src/atoms/CTPrice";
import { getLineItemsDiscountPrice } from "src/utils/ct/discountCodeHelper";
import { DiscountCodeInfo, LineItem } from "src/types/ctgraphql.d";

interface Props {
  discountCodes: DiscountCodeInfo[];
  lineItems: LineItem[];
}

const CartLineItemsDiscount: FC<Props> = ({ discountCodes, lineItems }) => {
  const discountPrice = useMemo(
    () => getLineItemsDiscountPrice(discountCodes, lineItems),
    [discountCodes, lineItems]
  );

  return !discountPrice ? null : (
    <Box data-testid="cart-line-items-discount">
      - <CTPrice price={discountPrice} />
    </Box>
  );
};

export default CartLineItemsDiscount;
